var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "product-selections__row product-selections__row--finish" },
    [
      _c(
        "td",
        {
          staticClass:
            "product-selections__cell product-selections__cell--item product-selections__cell--finish"
        },
        [_vm._v(_vm._s(_vm.accessory.title) + ":")]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "product-selections__cell product-selections__cell--qty",
          attrs: { colspan: "1" }
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.qty,
                expression: "qty"
              }
            ],
            staticClass: "input--qty",
            attrs: { type: "number" },
            domProps: { value: _vm.qty },
            on: {
              change: function($event) {
                return _vm.onAccessoryQtyChange()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.qty = $event.target.value
              }
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass:
            "product-selections__cell product-selections__cell--pricenovat"
        },
        [_vm._v("£" + _vm._s(_vm.qtyPrice))]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass:
            "product-selections__cell product-selections__cell--priceplusvat"
        },
        [_vm._v("£" + _vm._s(_vm.qtyPricePlusVat))]
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass:
            "product-selections__cell product-selections__cell--remove"
        },
        [
          _c(
            "span",
            {
              staticClass: "remove",
              on: {
                click: function($event) {
                  return _vm.$emit("accessoryRemoved", _vm.accessory)
                }
              }
            },
            [_vm._v("×")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }